import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker as MuiDateTimePicker, DateTimePickerProps as MuiDateTimePickerProps } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "designSystem/components/textfield/TextField";
import React, { FunctionComponent, useState } from "react";
import { defaultDateFormat, defaultTimeFormat, useLocale } from "designSystem/locale";
import { formatDateTime } from "./DatePicker";

export type DateTimePickerProps = Partial<Omit<MuiDateTimePickerProps<Date, Date>, "format">>;

const DateTimePicker: FunctionComponent<DateTimePickerProps> = (props) => {
	const { value, onChange, ...otherProps } = props;
	const [selectedDate, setSelectedDate] = useState<Date>(value || null);
	const loc = useLocale();
	const dateFormat = formatDateTime(loc.getDatePattern() || defaultDateFormat);
	const timeFormat = formatDateTime(loc.getTimePattern() || defaultTimeFormat);
	const dateTimeFormat = `${dateFormat} ${timeFormat}`;

	const handleDateChange = (value: Date): void => {
		setSelectedDate(value);
		onChange?.(value);
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<MuiDateTimePicker
				DialogProps={{
					className: "csi-date-picker-popper",
				}}
				PopperProps={{
					className: "csi-date-picker-popper",
					placement: "bottom-start",
				}}
				components={{
					OpenPickerIcon: QueryBuilderIcon,
				}}
				inputFormat={dateTimeFormat}
				onChange={handleDateChange}
				renderInput={(props) => <TextField {...props} />}
				value={selectedDate}
				{...otherProps}
			/>
		</LocalizationProvider>
	);
};

export default DateTimePicker;